// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1q511ejb{padding-block-start:var(--ds-space-300,24px)}\n._2lx21bp4{flex-direction:column}\n._4cvr1h6o{align-items:center}\n._85i5pxbi{padding-block-end:var(--ds-space-200,1pc)}\n._85i5ze3t{padding-block-end:var(--ds-space-0,0)}\n._bozgoahv{padding-inline-start:var(--ds-space-600,3pc)}\n._p12fko4j{max-width:19pc}\n._y3gn1h6o{text-align:center}\n._y4tioahv{padding-inline-end:var(--ds-space-600,3pc)}", ""]);
// Exports
module.exports = exports;
